import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    // lng: 'en',
    fallbackLng: 'en',
    backend: { loadPath: 'locales/{{lng}}/{{ns}}.json' },
     
     detection: {
      // order: ['queryString', 'cookie'],
      //    cache: ['cookie']
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
        },
    interpolation: {
      escapeValue: false,
      },
  
  });

export default i18n;